import { createSlice } from '@reduxjs/toolkit';
import {
  setNotificationDataReducer,
  removeNotificationByIndexReducer,
  removeNotificationByIdReducer,
} from './toastNotificationReducers';

export interface ToastNotificationState {
  data: any;
}

const initialState: ToastNotificationState = {
  data: {
    addedNewData: false,
    latestData: [],
  },
};

const toastNotificationSlice = createSlice({
  name: 'ToastNotification',
  initialState,
  reducers: {
    setNotificationData: setNotificationDataReducer,
    removeNotificationByIndex: removeNotificationByIndexReducer,
    removeNotificationById: removeNotificationByIdReducer,
  },
});

export const { setNotificationData, removeNotificationByIndex, removeNotificationById } =
  toastNotificationSlice.actions;
export default toastNotificationSlice.reducer;
